const cart = document.querySelector('.fixed-cart');
const about = document.querySelector('.about-product');
const advantages = document.querySelector('.advantages-product');

if (cart) {
  document.addEventListener('scroll', scrollDocumentHandler);
}

function scrollDocumentHandler() {
  if (about.getBoundingClientRect().bottom < 0) {
    cart.classList.add('active-desktop');
  } else {
    cart.classList.remove('active-desktop');
  }

  if (advantages.getBoundingClientRect().top < 0) {
    cart.classList.add('active-mobile');
  } else {
    cart.classList.remove('active-mobile');
  }
}
